import { httpGet } from './http';
import store from '../services/createStore';
import * as Actions from '../actions';

export const getUserName = async (accessToken) => {
    const { name } = await httpGet('https://geoauth-qa.geomant.cloud/connect/userinfo', { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` });
    console.log(name);
    store.dispatch(Actions.saveUserName(name));
}